﻿import React from 'react';

import { PartnerForm } from 'pages/partners/components/PartnerForm/PartnerForm';
import { Partner, PartnerDetails } from 'apis/PartnerApi';

import 'pages/partners/components/DetailsTab/styles/details-tab.scss';

interface DetailsTabProps {
    getPartnerTypeName: () => string;
    onDetailsItemClick: (dataItem: Partner, newPartner?: boolean) => Promise<void>;
    partnerDetails: PartnerDetails;
}

export const DetailsTab = ({ getPartnerTypeName, onDetailsItemClick, partnerDetails }: DetailsTabProps) => (
    <div className="details">
        <PartnerForm
            details={partnerDetails}
            getPartnerTypeName={getPartnerTypeName}
            onDetailsItemClick={onDetailsItemClick}
        />
    </div>
);
